<ng-container *transloco="let translate">
  <button mat-icon-button [matMenuTriggerFor]="languages" aria-label="Select language">
    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: activeLanguage}"></ng-container>
  </button>
  <mat-menu [xPosition]="'before'" #languages="matMenu">
    @for (language of availableLanguages; track trackBy($index, language)) {
    <button mat-menu-item [class.bg-gray-700]="isActive(language.id)"
      (click)="setActiveLanguageAndUpdateForUser(language.id)">
      <span class="flex items-center">
        <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: language.id}"></ng-container>
        <span class="ml-3" [class.font-semibold]="isActive(language.id)">{{ translate(language.label) }}</span>
        @if (language.id === activeLanguage) {
        <mat-icon color="primary" class="ml-2">check</mat-icon>
        }
      </span>
    </button>
    }
  </mat-menu>
  <ng-template let-language #flagImage>
    <span class="relative w-6 shadow rounded-sm overflow-hidden">
      <span class="absolute inset-0 ring-1 ring-inset ring-black ring-opacity-10"></span>
      <img class="w-full" [src]="getFlagPath(language)" />
    </span>
  </ng-template>
</ng-container>
